import { render } from "./Setting.vue?vue&type=template&id=e091af12&scoped=true&ts=true"
import script from "./Setting.vue?vue&type=script&lang=ts"
export * from "./Setting.vue?vue&type=script&lang=ts"

import "./Setting.vue?vue&type=style&index=0&id=e091af12&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e091af12"]])

export default __exports__